import { Component, OnInit,Input, ViewChild, Inject } from '@angular/core';
import { Agent,AgentServicev2 } from '../agent-builder-services/agent.service';
import { NZ_MODAL_DATA, NzModalService } from 'ng-zorro-antd/modal';
import { LanguageServices } from 'src/app/services/LanguageServices';


export interface RoundMessage {
  role: 'user' | 'assistant' | 'tool' | 'system';
  message: string;
  completionId?: string;
  promptToken?: number;
  completionTokens?: number;
  totalTokens?: number;
  toolName?: string;
  toolOutput?: any;
  subRole?: string; 
  createdAt?: string;
}

export interface Round {
  createdAt: string;
  query: string;
  answer: string | null;
  messages: RoundMessage[];
  labels: string[];
  _id: string;
  sessionId: string;
  userId: number;
}

@Component({
  selector: 'agent-builder-messages-log-detail',
  templateUrl: './agent-builder-messages-log-detail.component.html',
  styleUrls: ['./agent-builder-messages-log-detail.component.scss'],
  standalone: false
})
export class AgentBuilderMessagesLogDetailComponent implements OnInit {
  rounds: Round[] = [];
  loading = false;

  
  
  constructor(private agentService: AgentServicev2, @Inject(NZ_MODAL_DATA) public nzData: any) {}

  agent: Agent;
  sessionId: string;

  ngOnInit() {
    this.agent = this.nzData.agent;
    this.sessionId = this.nzData.sessionId;
    this.loadData();
  }

  loadData() {
    console.log(this.agent)
    if ( this.agent.qaTable==null || this.agent.qaTable.trim() == '' ) {
      return;
    }
    setTimeout(() => {
      this.loading = true;
    }, 0);

    this.agentService
      .getLogMessageDetail(this.agent, this.sessionId)
      .subscribe((res:any) => {
        this.rounds = res.SQL || [];
        this.loading = false;
      });
  }

  parseData(data: string): any {
    if ( data == null || data.trim() === '') {
      return '{}';
    }
    try {
      return JSON.stringify(JSON.parse(data),null, 2);
    } catch {
      return JSON.stringify(data, null, 2);
    } 
  }

  getAvatarAll(msg: RoundMessage): string {
    const text:string = (msg.message ?? '').replace(/^[\s\n\r\t]+/, '');
  
    // Só aplica prefixos quando role = user
    if (msg.role === 'user') {

      if (msg.subRole == 'feedback' || text.trim().startsWith('Contexto Feeback:')||text.trim().startsWith('Contexto Feedback:')) {
        return "https://api.dicebear.com/7.x/icons/svg?seed=feedback";
      }

      if (msg.subRole == 'user-doc' || text.trim().startsWith('Contexto Documentação Usuário:')) {
        return "https://api.dicebear.com/7.x/icons/svg?seed=user-doc";
      }

      if (msg.subRole == 'rag-doc' || text.trim().startsWith('Contexto Documentação:')) {
        return "https://api.dicebear.com/7.x/icons/svg?seed=rag-doc";
      }
    }

      return this.getAvatar(msg.role);
    }
    
    getAvatar(role: string): string {
      switch (role) {
        case 'user':
          return 'https://api.dicebear.com/7.x/personas/svg?seed=user';
        case 'assistant':
          return 'https://api.dicebear.com/7.x/bottts/svg?seed=llm';
        case 'tool':
          return 'https://api.dicebear.com/7.x/shapes/svg?seed=tool';
        case 'system':
          return "https://api.dicebear.com/7.x/icons/svg?seed=prompt";
        default:
          return '';
        }
    }

    getRoleLabel(msg: RoundMessage): string {
      const text = (msg.message ?? '').replace(/^[\s\n\r\t]+/, '');

      // Só aplica prefixos quando role = user
      if (msg.role === 'user') {
          

        if (msg.subRole == 'feedback' || text.trim().startsWith('Contexto Feeback:')||text.trim().startsWith('Contexto Feedback:')) {
          return 'Feedback';
        }

        if (msg.subRole == 'user-doc' || text.trim().startsWith('Contexto Documentação Usuário:')) {
          return 'Doc Usuário';
        }

        if (msg.subRole == 'rag-doc' || text.trim().startsWith('Contexto Documentação:')) {
          return 'Doc RAG';
        }

        return 'Usuário';
      }

      if (msg.role === 'system') {
        return 'Sistema';
      }

      // assistant
      if (msg.role === 'assistant') {
        return 'LLM';
      }

      // tool
      if (msg.role === 'tool') {
        return `Tool: ${msg.toolName ?? 'Unknown'}`;
      }

      return 'Mensagem'
    }
  

    getBubbleClass(msg: RoundMessage): string {
      const text = (msg.message ?? '').replace(/^[\s\n\r\t]+/, '');
      if (msg.role === 'user') {

        if (msg.subRole == 'feedback' || text.trim().startsWith('Contexto Feeback:')||text.trim().startsWith('Contexto Feedback:')) {
          return 'bubble-feedback';
        }

        if (msg.subRole == 'user-doc' || text.trim().startsWith('Contexto Documentação Usuário:')) {
          return 'bubble-doc-user';
        }

        if (msg.subRole == 'rag-doc' || text.trim().startsWith('Contexto Documentação:')) {
          return 'bubble-doc-rag';
        }

        return 'bubble-user';
      }

      if (msg.role === 'assistant') return 'bubble-assistant';
      if (msg.role === 'tool') return 'bubble-tool';
      if (msg.role === 'system') return 'bubble-instrucoes';
     

      return 'bubble-default';

    }
 
}